// Dates civiles, sans conversion de fuseau horaire : affichage JJ/MM/AAAA,
// valeur persistée et transmise à Salesforce AAAA-MM-JJ.
function isISODate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split('-').map(Number);
  if (year < 1 || month < 1 || month > 12 || day < 1) return false;
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  return day <= [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
}
function toISODate(value) {
  const text = String(value ?? '').trim();
  if (isISODate(text)) return text;
  const match = /^(\d{2})[/-](\d{2})[/-](\d{4})$/.exec(text);
  const iso = match ? `${match[3]}-${match[2]}-${match[1]}` : '';
  return isISODate(iso) ? iso : '';
}
function formatDateDigits(value) {
  const digits = String(value ?? '').replace(/\D/g, '').slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean).join('/');
}
function displayDate(value) {
  const text = String(value ?? '').trim();
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
  return iso ? `${iso[3]}/${iso[2]}/${iso[1]}` : formatDateDigits(text);
}
function dateError(value, lang = 'fr') {
  if (!value || toISODate(value)) return '';
  return lang === 'en' ? 'Enter a valid date in DD/MM/YYYY format.' : 'Saisissez une date valide au format JJ/MM/AAAA.';
}
// Même date de référence côté navigateur et serveur, quel que soit leur fuseau.
const parisDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
});
function birthDateBounds(now = new Date()) {
  const parts = Object.fromEntries(parisDate.formatToParts(now).map(part => [part.type, part.value]));
  const year = Number(parts.year);
  function yearsAgo(years) {
    const prefix = `${year - years}-${parts.month}`;
    const candidate = `${prefix}-${parts.day}`;
    // Le 29 février, le dernier anniversaire possible est le 28 février
    // lorsque l'année de naissance n'est pas bissextile.
    return isISODate(candidate) ? candidate : `${prefix}-28`;
  }
  const hundredthBirthday = new Date(`${yearsAgo(100)}T00:00:00Z`);
  hundredthBirthday.setUTCDate(hundredthBirthday.getUTCDate() + 1);
  return { min: hundredthBirthday.toISOString().slice(0, 10), max: yearsAgo(13) };
}
function isBirthDateQuestion(question) {
  return Boolean(question && (question.idForm === '00NaT000001BMEL'
    || (question.type === 'date' && (String(question.placeholder) === '11'
      || /naissance|birth/i.test(`${question.nom || ''} ${question.etiquette || ''}`)))));
}
function birthDateError(value, lang = 'fr') {
  const invalid = dateError(value, lang);
  if (invalid || !value) return invalid;
  const iso = toISODate(value);
  const { min, max } = birthDateBounds();
  if (iso > max) return lang === 'en' ? 'You must be at least 13 years old.' : 'Vous devez avoir au moins 13 ans.';
  if (iso < min) return lang === 'en' ? 'You must be no older than 99.' : 'Vous devez avoir au maximum 99 ans.';
  return '';
}
function questionDateError(question, value, lang = 'fr') {
  return isBirthDateQuestion(question) ? birthDateError(value, lang) : dateError(value, lang);
}
module.exports = { isISODate, toISODate, formatDateDigits, displayDate, dateError,
  birthDateBounds, isBirthDateQuestion, birthDateError, questionDateError };
